<template>
    
    <div class="embed-video">
        <div 
            class="video-container"
            ref="videoContainer"
            :style="{ paddingBottom: padding+'%', backgroundColor: backgroundColor}"
            @click="onPlayVimeo"
        >
            <div class="vimeo-player" ref="vimeo"></div>
            <!-- <div class="close-vimeo" @click="onPauseVimeo"></div> -->
            
            <video-loader
                ref="video"
                :data="data.video.urls"
                :autoplay=true 
                :loop=true
                @loaded="onVideoLoaded"
            />
            
            <div class="play-button" ref="playButton">
                <svg viewBox="0 0 20 20" preserveAspectRatio="xMidYMid">
                    <polygon class="fill" points="1,0 20,10 1,20"></polygon>
                </svg>
            </div>
        </div>
    </div>
    
</template>


<script>
import VideoLoader from '@/components/VideoLoader'
import VimeoPlayer from '@vimeo/player';
// import Size from '@/plugins/WindowSize'

export default {
    
    props: {
        data: {
            type: Object,
            required: true,
            default: () => {},
        }
    },
    
    components: {
        VideoLoader
    },
    
    data() {
        return {
            padding: 0,
            backgroundColor: '',
            vimeoUrl: 'https://vimeo.com/72420929',
        }
    },
    
    created() {
        this.backgroundColor = this.data.backgroundColor
        // Size.addListener(this.onResize)
    },
    
    destroyed() {
        // Size.removeListener(this.onResize)
    },
    
    mounted() {
        
        let width = this.data.video.urls[0].width
        let height = this.data.video.urls[0].height
        this.padding = (height/width)*100
        
        // https://player.vimeo.com/video/72420929/config?autopause=1&autoplay=1&byline=0&default_to_hd=1&responsive=1&outro=nothing&controls=0&portrait=0&dnt=true
        var options = {
          url: this.vimeoUrl,
          width: 1920,
          height: 1080,
          autopause: 1,
          autoplay: 0,
          muted: 0,
          responsive: 1, // wrap's player in div with padding-bottom %
          playsinline: 1, // plays inline on supported mobile devices
          controls: 1, // show controls
          portrait: 0, // show video owner's portrait
          title: 0, // show video owner's title
          byline: 0, // display the video owner's name.
          dnt: true, // disable cookies
          outro: 'nothing', // not documented but used on Vimeo.com
          default_to_hd: 1, // not documented but used on Vimeo.com
          // quality: 360p, 540p, 720p, 1080p, 2k, and 4k. // Set initial quality
        };
        
        // Load Player
        // https://www.npmjs.com/package/@vimeo/player
        this.vimeoPlayer = new VimeoPlayer(this.$refs.vimeo, options); 
        
    },
    
    methods: {
        
        onPlayVimeo() {
            
            // if (this.isCaseFullWidth === true) {}
            this.showVimeoPlayer()
            this.vimeoPlayer.play();
            
            // if (window.innerWidth < 1024) {
            //     this.showVimeoPlayer()
            // }
        },
        
        // onPauseVimeo(event) {
        //     this.vimeoPlayer.pause();
        // },
        
        showVimeoPlayer() {
            TweenLite.to(this.$refs.video.$el, 0.4, {delay: 1.2, autoAlpha: 0}); // Scale Case 0.6s
            TweenLite.to(this.$refs.playButton, 0.4, {autoAlpha: 0});
            TweenLite.set(this.$refs.vimeo, {delay: 1, opacity: 1});
        },
        
        hideVimeoPlayer() {
            TweenLite.to(this.$refs.playButton, 0.4, {autoAlpha: 1});
            TweenLite.to(this.$refs.video.$el, 0.4, {autoAlpha: 1, overwrite:'all', onComplete: () => {
                TweenLite.set(this.$refs.vimeo, {opacity: 0});
                this.vimeoPlayer.pause();
                this.vimeoPlayer.setCurrentTime(0) // restart?
            }});
        },
        
        onVideoLoaded() {
            
            // this.backgroundColor = 'transparent'
            TweenLite.to(this.$refs.video.$el, 2, {opacity: 1});
            this.$emit('loaded')
        },
        
        // onResize() {},
        
    },
    
    computed: {
        isCaseFullWidth() {
            return this.$store.state.isCaseFullWidth
        },
    },
    
    watch: {
        isCaseFullWidth(newValue) {
            // console.log('isCaseFullWidth changed: ', newValue, OldValue);
            
            if (newValue === true) {
                // this.showVimeoPlayer()
                
            } else {
                this.vimeoPlayer.pause();
                // this.hideVimeoPlayer()
            }
        },
    },

    
}

</script>


<style lang="scss" scoped>
@import '../scss/variables';

.embed-video {
    .video-container {
        position: relative;
        height: 0;
        font-size: 11px;
        
        &:hover {
            .play-button {
                background-color: rgba(0, 173, 239, 1);
            }
        }
        
        .vimeo-player {
            opacity: 0;
        }
        
        .play-button {
            position: absolute;
            
            top: 50%;
            left: 50%;
            width: 6.5em;
            height: 4em;
            margin-top: calc(-4em/2);
            margin-left: calc(-6.5em/2);
            
            background-color: rgba(23,35,34,.75);
            border-radius: 0.5em;
            cursor: pointer;
            
            svg {
                width: 2em;
                height: 2em;
                margin-left: calc(4.5em/2);
                margin-top: calc(2em/2);
                .fill {
                    fill: #fff; 
                }
            }
            
        }
        
        video {
            position: absolute;
            top: 0;
            opacity: 0; // JS Fade-in
        }
        
        // .close-vimeo {
        //     position: absolute;
        //     top: 0;
        //     left: 0;
        //     width: 100%;
        //     height: 85%;
        // 
        //     // // TEMP
        //     // border: 1px solid red;
        //     // &:before {
        //     //     position: absolute;
        //     //     top: 10px;
        //     //     left: 10px;
        //     //     content: 'BLOCK CONTROLS';
        //     //     font-size: 20px;
        //     //     color: red;
        //     // }
        // }
    }
}
</style>
